import React from "react";
import {
    Datagrid,
    DateField, Filter,
    List,
    SimpleShowLayout,
    TextField,
    TextInput,
    AutocompleteArrayInput, ArrayField, ReferenceField,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import {UserConditions} from "../../constants/choices";

const UserConversationFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId"/>
    <TextInput label="شناسه چت" source="conversationId"/>
  </Filter>
);

export const UserConversationList = (props) => (
  <List {...props} filters={<UserConversationFilter/>}>
    <Datagrid rowClick="show">
      <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user">
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
      <ArrayField source="userConditions">
          <Datagrid>
              <TextField source="conditions" />
          </Datagrid>
      </ArrayField>
      <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </Datagrid>
  </List>
);

export const UserConversationShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user">
            <TextField source="name"/>
        </ReferenceField>
        <ReferenceField link="show" label="مکالمه" source="conversationId" reference="conversation" >
            <TextField source="title"/>
        </ReferenceField>
        <ArrayField source="userConditions">
            <Datagrid>
                <TextField source="conditions" />
            </Datagrid>
        </ArrayField>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
        <DateField showTime={true} locales={"fa-IR"} source="updatedAt"/>
    </SimpleShowLayout>
  </ShowView>
);

export const UserConversationEdit = (props) => (
  <EditView {...props}>
      <AutocompleteArrayInput source="conditions" choices={UserConditions}/>
  </EditView>
);

export const UserConversationCreate = (props) => (
  <CreateView {...props}>
      <TextInput source="userId"/>
      <TextInput source="conversationId"/>
      <AutocompleteArrayInput source="conditions" choices={UserConditions}/>
  </CreateView>
);